/**
 * Authentication Mode Management Utility
 * Manages switching between Okta and Keycloak authentication providers
 */

export const AUTH_MODES = {
    OKTA: 'okta',
    KEYCLOAK: 'keycloak'
};

/**
 * Get the current authentication mode from localStorage
 * @returns {string} The current auth mode (okta or keycloak)
 */
export const getAuthMode = () => {
    const stored = localStorage.getItem('authMode');
    const result = stored || AUTH_MODES.OKTA; // Default to Okta
    return result;
};

/**
 * Set the authentication mode
 * @param {string} mode - The auth mode to set (okta or keycloak)
 * @throws {Error} If invalid mode is provided
 */
export const setAuthMode = (mode) => {
    if (!Object.values(AUTH_MODES).includes(mode)) {
        throw new Error(`Invalid auth mode: ${mode}. Must be one of: ${Object.values(AUTH_MODES).join(', ')}`);
    }
    localStorage.setItem('authMode', mode);
};

/**
 * Clear the authentication mode preference
 */
export const clearAuthMode = () => {
    localStorage.removeItem('authMode');
};

/**
 * Check if current mode is Keycloak
 * @returns {boolean}
 */
export const isKeycloakMode = () => getAuthMode() === AUTH_MODES.KEYCLOAK;

/**
 * Check if current mode is Okta
 * @returns {boolean}
 */
export const isOktaMode = () => getAuthMode() === AUTH_MODES.OKTA;
